export default {
    manage_deleteWorkOrderType_title: "Eliminar Tipo de Órden de Trabajo",
    manage_deleteWorkOrderTypes_title: "Eliminar Tipos de Órdenes de Trabajo",
    manage_deleteWorkOrderTypes_description: "¿Está seguro de que desea eliminar estos tipos de orden de trabajo?",
    manage_deleteWorkOrderType_description: "¿Está seguro de que desea eliminar este tipo de orden de trabajo?",
    manage_deleteWorkOrderType_successMessage: "Tipo de orden de trabajo eliminada",
    manage_deleteWorkOrderTypes_successMessage: "Tipos de órdenes de trabajo eliminadas",
    manage_deleteWorkOrderTypes_are_in_use: "No es posible eliminar tipos de órdenes de trabajo en uso",
}